import React from "react"

import "../styles/pages/home.scss"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ImageMainBgInlineSvg from "../images/image-main-bg.inline.svg"
import ImageMain from "../components/images/image-main"
import ButtonDownload from "../components/home/button-download"
import Header from "../components/header"
import ImageFeaturesInlineSvg from "../images/image-features.inline.svg"
import ImageForwardBgInlineSvg from "../images/image-forward-bg.inline.svg"
import ImageSimpleSecureInlineSvg from "../images/image-simple-secure.inline.svg"
import ImageForward from "../components/images/image-forward"
import ServiceElasticInlineSvg from "../images/services/elastic.inline.svg"
import ServiceGrafanaInlineSvg from "../images/services/grafana.inline.svg"
import ServiceKibanaInlineSvg from "../images/services/kibana.inline.svg"
import ServiceMongoInlineSvg from "../images/services/mongo.inline.svg"
import ServiceMysqlInlineSvg from "../images/services/mysql.inline.svg"
import ServicePostgresInlineSvg from "../images/services/postgres.inline.svg"
import ServicePrometeusInlineSvg from "../images/services/prometeus.inline.svg"
import ServiceRedisInlineSvg from "../images/services/redis.inline.svg"

const IndexPage = () => (
  <Layout className="page_name_home" parallax>
    <SEO title="Easy to use Kubernetes port forwarding manager"/>

    <div className="page__gradient page__gradient_pos_1"/>
    <div className="page__gradient page__gradient_pos_2"/>
    <div className="page__gradient page__gradient_pos_3"/>
    <div className="page__gradient page__gradient_pos_4"/>

    <main>
      <div className="page__container">
        <div className="page__header">
          <h1 className="page__title">
            Easy to use <span className="text_theme_gradient text_weight_bold">Kubernetes</span> port forwarding manager
          </h1>
          <ButtonDownload/>
          <div className="page__description">
            Open-source MIT Licensed. Find on <a className="link" href="https://github.com/pixel-point/kube-forwarder" target="_blank">Github</a>
          </div>
        </div>
      </div>

      <div className="page__screenshot page__screenshot_name_main page__container">
        <ImageMainBgInlineSvg/>
        <ImageMain/>
      </div>

      <div className="page__container">
        <div className="section section_name_features" id="features">
          <div className="section__title"><span className="text_theme_gradient">Features</span></div>
          <div className="section__content">
            <div className="section__image"><ImageFeaturesInlineSvg/></div>
            <ul className="section__list">
              <li className="section__list-item">
                <div className="section__list-item-title">Auto-reconnect</div>
                <div className="section__list-item-content">
                  Kube Forwarder watches for connection status and always tries reconnect on failure
                </div>
              </li>
              <li className="section__list-item section__list-item_style_secondary">
                <div className="section__list-item-title">Multiple clusters support</div>
                <div className="section__list-item-content">
                  Bookmark and forward Kubernetes services from multiple clusters easily like never before
                </div>
              </li>
              <li className="section__list-item section__list-item_style_secondary section__list-item_column_2">
                <div className="section__list-item-title">Share bookmarks</div>
                <div className="section__list-item-content">
                  Use import and export functionality to share bookmarked services with your team or simply backup it
                </div>
              </li>
              <li className="section__list-item section__list-item_column_2">
                <div className="section__list-item-title">Zero native dependencies</div>
                <div className="section__list-item-content">
                  Use port-forwarding without installing kubectl and avoid explanations to developers on how to use it
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="section section_name_forward">
          <div className="section__content">
            <div className="section__block">
              <div className="section__block-title">
                Forward <span className="text_theme_gradient">multiple&nbsp;services</span>
                <br/> at the same time
              </div>
              <ButtonDownload/>
              <div className="page__description">
                Open-source. Find on <a className="link" href="https://github.com/pixel-point/kube-forwarder" target="_blank">Github</a>
              </div>
            </div>
            <div className="section__image page__screenshot page__screenshot_name_forward">
              <ImageForwardBgInlineSvg/>
              <ImageForward/>
            </div>
          </div>
        </div>

        <div className="section section_name_simple-secure" id="simple-secure">
          <div className="section__title"><span className="text_theme_gradient">Port Forwarding Advantages</span></div>
          <div className="section__content">
            <div className="section__image"><ImageSimpleSecureInlineSvg/></div>
            <ul className="section__list">
              <li className="section__list-item">
                <div className="section__list-item-title">Security</div>
                <div className="section__list-item-content">
                  You don't need expose services to the global network, install extra Auth reverse proxy services or use a VPN
                </div>
              </li>
              <li className="section__list-item section__list-item_style_secondary">
                <div className="section__list-item-title">Works everywhere</div>
                <div className="section__list-item-content">
                  Using reverse proxy does not work with all services and requires extra configuration from developers, when port forwarding works with almost any services out of the box
                </div>
              </li>
              <li className="section__list-item">
                <div className="section__list-item-title">Simple debugging</div>
                <div className="section__list-item-content">
                  Connect to any pod with port-forwarding in the cluster and investigate the problem, without exposing your service globally
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="section section_name_services" id="works-with">
          <div className="section__content">
            <div className="section__block">
              <div className="section__block-title">
                Kube Forwarder <span className="text_theme_gradient">Works&nbsp;With</span>
              </div>
              <ButtonDownload/>
              <div className="page__description">
                Open-source. Find on <a className="link" href="https://github.com/pixel-point/kube-forwarder" target="_blank">Github</a>
              </div>
            </div>
            <div className="section__services">
              <div className="service-logo service-logo_floating service-logo_name_elastic"><ServiceElasticInlineSvg/><div className="service-logo__name">Elastic</div></div>
              <div className="service-logo service-logo_floating service-logo_name_grafana"><ServiceGrafanaInlineSvg/><div className="service-logo__name">Grafana</div></div>
              <div className="service-logo service-logo_floating service-logo_name_kibana"><ServiceKibanaInlineSvg/><div className="service-logo__name">Kibana</div></div>
              <div className="service-logo service-logo_floating service-logo_name_mongo"><ServiceMongoInlineSvg/><div className="service-logo__name">MongoDB</div></div>
              <div className="service-logo service-logo_floating service-logo_name_mysql"><ServiceMysqlInlineSvg/><div className="service-logo__name">MySQL</div></div>
              <div className="service-logo service-logo_floating service-logo_name_postgres"><ServicePostgresInlineSvg/><div className="service-logo__name">PostgreSQL</div></div>
              <div className="service-logo service-logo_floating service-logo_name_prometeus"><ServicePrometeusInlineSvg/><div className="service-logo__name">Prometeus</div></div>
              <div className="service-logo service-logo_floating service-logo_name_redis"><ServiceRedisInlineSvg/><div className="service-logo__name">Redis</div></div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Header className="header_position_bottom"/>
  </Layout>
)

export default IndexPage
